export { default as Text } from "./Text";
export { CustomTextProps } from "./Text";
